
export { default as SaleCertificate } from './items/saleCertificate.jsx';
export {
  BenefitsPurchaseTickets,
} from './items/BenefitsPurchaseTickets/index.jsx';
export { AttendanceRules } from './items/AttendanceRules';
export { NewGermanyCinema26 } from './items/NewGermanyCinema26';
export {
  HearingAndVisionImpairmentsV2,
} from './items/HearingAndVisionImpairmentsV2';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/index.jsx